import { ProfileInfoCardStyled, } from "./styled/ProfileInfoCardStyled";
import { Button } from "react-bootstrap";
import BinIcon from "../icon/Icon";

interface IProfileInfoCardProps {
    btnIcon: string,
    btnText: string,
    disabled?: boolean
    onClick: () => void,
    text: string,
    textIcon: string,
    title: string,
}

export default function ProfileInfoCard(props: IProfileInfoCardProps) {
    const {
        btnIcon,
        btnText,
        disabled = false,
        onClick,
        text,
        textIcon,
        title,
    } = props;
    return (
        <ProfileInfoCardStyled.Container>
            <ProfileInfoCardStyled.Row className={'mw-100'}>
                <BinIcon name={textIcon} className={'me-2'} size="24px" style={{ minWidth: '1em' }}/>
                <ProfileInfoCardStyled.Column style={{maxWidth: 'calc(100% - 32px)'}}>
                    <ProfileInfoCardStyled.Title className="mt-1 ellipsis">
                        {title}
                    </ProfileInfoCardStyled.Title>
                    <ProfileInfoCardStyled.Text className={'word-break-word'}>
                        {text}
                    </ProfileInfoCardStyled.Text>
                </ProfileInfoCardStyled.Column>
            </ProfileInfoCardStyled.Row>
            <Button variant={'secondary'} className="w-100 mt-2" onClick={onClick} disabled={disabled}>
                <span>{btnText}</span>
                <BinIcon name={btnIcon} className={'ms-2'} size={'1.2em'}/>
            </Button>
        </ProfileInfoCardStyled.Container>
    );
}

